import React, { Component } from 'react'
import { connect } from 'react-redux'
import TextareaAutosize from 'react-autosize-textarea'
import { withI18n } from '@lingui/react'
import classnames from 'classnames'
import {
  getCurrentQuestionId,
  getCurrentComment,
  getIsCommentFieldEnabled,
} from '../selectors.js'
import './CommentField.css'

// poor man's mobile detect
const IS_MOBILE = typeof window.orientation !== 'undefined'

class CommentField extends Component {
  componentWillReceiveProps({ enabled }) {
    if (enabled && !this.enabled && !IS_MOBILE) this.textarea.focus()
  }

  render() {
    const { questionId, comment, enabled, i18n, setComment } = this.props
    const ph = i18n.t`Write down what made you feel that way. (optional)`
    const classes = classnames({
      CommentField: true,
      enabled,
    })
    return (
      <div className={classes}>
        <TextareaAutosize
          rows={2}
          maxRows={4}
          placeholder={ph}
          value={comment}
          onChange={e => setComment({ questionId, comment: e.target.value })}
          innerRef={textarea => (this.textarea = textarea)}
          maxLength={1024}
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  questionId: getCurrentQuestionId(state),
  comment: getCurrentComment(state),
  enabled: getIsCommentFieldEnabled(state),
})

const mapDispatchToProps = ({ commentsByQuestionId }) => ({
  setComment: payload => commentsByQuestionId.setComment(payload),
})

export default connect(mapStateToProps, mapDispatchToProps)(
  withI18n()(CommentField)
)



// WEBPACK FOOTER //
// ./src/components/CommentField.js